/**
 * @generated SignedSource<<99cdcb402c4b08465952232a45fb166f>>
 * @relayHash cc4b00ccc394b4720280876d37fb650f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/558.0.0-2026-05-07T16:07:11.910Z/homepageRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homepageRootQuery$variables = {
  abTestList?: ReadonlyArray<string | null> | null;
  fetchInitialHomepage: boolean;
  hasUserId: boolean;
  homepageId: string;
  isClient: boolean;
  isEvergreenCollectionsTestVariant: boolean;
  isHpSaleModuleVariant?: boolean | null;
  isMobile: boolean;
  isNewArrivalsCarouselTabsTestVariant: boolean;
  isRemoveShopByTestVariant: boolean;
  isRemoveTopHeroBannerTestVariant: boolean;
  isTrade: boolean;
  priceBookName: string;
  userCountryCode: string;
  userId: string;
  userType: string;
};
export type homepageRootQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedLayout_viewer" | "getHomePageMetaContent_viewer" | "isEmptyHomePage_viewer">;
  };
};
export type homepageRootQuery = {
  response: homepageRootQuery$data;
  variables: homepageRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": ([]/*: any*/),
  "kind": "LocalArgument",
  "name": "abTestList"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchInitialHomepage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasUserId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "homepageId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEvergreenCollectionsTestVariant"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isHpSaleModuleVariant"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isMobile"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNewArrivalsCarouselTabsTestVariant"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoveShopByTestVariant"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isRemoveTopHeroBannerTestVariant"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userType"
},
v16 = [
  {
    "kind": "Variable",
    "name": "abTestList",
    "variableName": "abTestList"
  },
  {
    "kind": "Variable",
    "name": "rootId",
    "variableName": "homepageId"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v18 = [
  {
    "kind": "RootArgument",
    "name": "abTestList"
  },
  {
    "kind": "RootArgument",
    "name": "homepageId"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "HomepageMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isHomepageUnionType"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v24 = [
  {
    "kind": "Variable",
    "name": "userType",
    "variableName": "userType"
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageHeight",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageWidth",
  "storageKey": null
},
v28 = {
  "condition": "isMobile",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageHeight",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mobileImageWidth",
      "storageKey": null
    }
  ]
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eyeBrowText",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerText",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dekText",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentColor",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cta",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMuxVideo",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoAutoplay",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsDisplayTitle",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cmsId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v35/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLinkable",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ctaLink",
  "storageKey": null
},
v43 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v49 = {
  "alias": "productPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 1
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "smallPath",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhotoVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "webPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v51/*: any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v51/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v55/*: any*/),
        (v45/*: any*/)
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v44/*: any*/),
                (v55/*: any*/),
                (v25/*: any*/),
                (v45/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v60 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v61 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "currency",
    "storageKey": null
  }
],
v62 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade"
    },
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v60/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": (v61/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v61/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "textType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amountType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isComplimentary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCalculated",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "kind": "LinkedField",
      "name": "totalAmount",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmounts",
          "kind": "LinkedField",
          "name": "convertedAmounts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "USD",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "regionName",
              "storageKey": null
            },
            (v45/*: any*/)
          ],
          "storageKey": null
        },
        (v45/*: any*/)
      ],
      "storageKey": null
    },
    (v45/*: any*/)
  ],
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": "mobileText",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE"
            }
          ],
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v55/*: any*/),
        (v41/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryTitle",
  "storageKey": null
},
v67 = [
  (v44/*: any*/),
  (v45/*: any*/)
],
v68 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v69 = [
  (v68/*: any*/),
  (v60/*: any*/),
  {
    "kind": "Literal",
    "name": "uriRef",
    "value": "/collections/editors-picks/"
  },
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  }
],
v70 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Item",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v44/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "size",
            "value": "thumb"
          }
        ],
        "kind": "ScalarField",
        "name": "firstPhotoWebPath",
        "storageKey": "firstPhotoWebPath(size:\"thumb\")"
      },
      (v19/*: any*/),
      (v48/*: any*/),
      (v46/*: any*/),
      (v47/*: any*/),
      {
        "condition": "hasUserId",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "heartPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "HEART"
              },
              (v43/*: any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioId",
                "storageKey": null
              },
              (v45/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "portfolioItemId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "folderPortfolioItems",
            "args": [
              {
                "kind": "Literal",
                "name": "portfolioType",
                "value": "FOLDER"
              },
              (v43/*: any*/)
            ],
            "concreteType": "PortfolioItemV2",
            "kind": "LinkedField",
            "name": "portfolioItems",
            "plural": true,
            "selections": [
              (v17/*: any*/),
              (v45/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      (v49/*: any*/),
      (v50/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v54/*: any*/),
      (v56/*: any*/),
      (v41/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/),
      (v59/*: any*/),
      (v62/*: any*/),
      (v63/*: any*/),
      (v64/*: any*/),
      (v65/*: any*/),
      (v45/*: any*/),
      (v17/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "cursor",
    "storageKey": null
  }
],
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": "favoritesPageRedesignFF",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "favoritesPageRedesign"
    }
  ],
  "kind": "ScalarField",
  "name": "featureFlag",
  "storageKey": "featureFlag(feature:\"favoritesPageRedesign\")"
},
v74 = {
  "condition": "hasUserId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": "userPortfolios",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "HEART"
          ]
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "kind": "LinkedField",
      "name": "portfolios",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v67/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v75 = [
  (v68/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "ON_SALE_MODULE"
  }
],
v76 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchTreandingEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v70/*: any*/),
    "storageKey": null
  },
  (v71/*: any*/),
  (v72/*: any*/)
],
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v78 = [
  (v68/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "MOST_SAVED_MODULE"
  }
],
v79 = [
  (v68/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "EXCELLENT_VALUES_MODULE"
  }
],
v80 = [
  (v68/*: any*/),
  {
    "kind": "Literal",
    "name": "module",
    "value": "BEST_SELLING_MODULE"
  }
],
v81 = [
  {
    "condition": "isClient",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "alias": "mostSavedItems",
        "args": (v78/*: any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v76/*: any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"MOST_SAVED_MODULE\")"
      },
      {
        "alias": "mostSavedItems",
        "args": (v78/*: any*/),
        "filters": ([]/*: any*/),
        "handle": "connection",
        "key": "HpSharedMostSavedItemsCarousel_mostSavedItems",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      },
      {
        "alias": "excellentValuesItems",
        "args": (v79/*: any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v76/*: any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"EXCELLENT_VALUES_MODULE\")"
      },
      {
        "alias": "excellentValuesItems",
        "args": (v79/*: any*/),
        "filters": ([]/*: any*/),
        "handle": "connection",
        "key": "HpSharedExcellentValuesCarousel_excellentValuesItems",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      },
      {
        "alias": "bestsellingDesigns",
        "args": (v80/*: any*/),
        "concreteType": "ItemSearchTreandingConnection",
        "kind": "LinkedField",
        "name": "itemSearchTrending",
        "plural": false,
        "selections": (v76/*: any*/),
        "storageKey": "itemSearchTrending(first:6,module:\"BEST_SELLING_MODULE\")"
      },
      {
        "alias": "bestsellingDesigns",
        "args": (v80/*: any*/),
        "filters": ([]/*: any*/),
        "handle": "connection",
        "key": "HpSharedBestsellingDesignsCarousel_bestsellingDesigns",
        "kind": "LinkedHandle",
        "name": "itemSearchTrending"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "homepageRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HpSharedLayout_viewer"
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "isEmptyHomePage_viewer",
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "Homepage",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": true,
                    "selections": [
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": (v18/*: any*/)
          },
          {
            "kind": "InlineDataFragmentSpread",
            "name": "getHomePageMetaContent_viewer",
            "selections": [
              {
                "alias": null,
                "args": (v16/*: any*/),
                "concreteType": "Homepage",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "args": null,
            "argumentDefinitions": (v18/*: any*/)
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v3/*: any*/),
      (v14/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v15/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "homepageRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v16/*: any*/),
            "concreteType": "Homepage",
            "kind": "LinkedField",
            "name": "homepage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  (v17/*: any*/),
                  {
                    "condition": "isRemoveTopHeroBannerTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": (v24/*: any*/),
                            "concreteType": "TopHeroBannerMessages",
                            "kind": "LinkedField",
                            "name": "messages",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TopHeroBannerItem",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  {
                                    "condition": "isMobile",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                      (v25/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  },
                                  (v28/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "HeroBannerSettingsType",
                                    "kind": "LinkedField",
                                    "name": "heroBannerSettings",
                                    "plural": false,
                                    "selections": [
                                      (v29/*: any*/),
                                      (v30/*: any*/),
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      (v33/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v34/*: any*/),
                                  (v36/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "videoUrl",
                                    "storageKey": null
                                  },
                                  (v37/*: any*/),
                                  (v38/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mediaFormat",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "TopHeroBannerModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "condition": "fetchInitialHomepage",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v19/*: any*/),
                          (v39/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v40/*: any*/),
                              (v19/*: any*/),
                              (v25/*: any*/),
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CollectionsModule",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": (v24/*: any*/),
                            "concreteType": "EditorialItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              (v19/*: any*/),
                              (v34/*: any*/),
                              (v36/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "EditorialModule",
                        "abstractKey": null
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "index",
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": (v24/*: any*/),
                        "concreteType": "PromoModuleMessages",
                        "kind": "LinkedField",
                        "name": "messages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PromoItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                              (v17/*: any*/),
                              (v40/*: any*/),
                              {
                                "condition": "isMobile",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/)
                                ]
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageCopy",
                                "storageKey": null
                              },
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isFullBleedImage",
                                "storageKey": null
                              },
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "format",
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HeroBannerSettingsType",
                                "kind": "LinkedField",
                                "name": "heroBannerSettings",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "textAlignment",
                                    "storageKey": null
                                  },
                                  (v33/*: any*/),
                                  (v29/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "ctaStyle",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "contentPosition",
                                    "storageKey": null
                                  },
                                  (v32/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "bannerImageWidth",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaCopy",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v39/*: any*/)
                    ],
                    "type": "PromoModule",
                    "abstractKey": null
                  },
                  {
                    "condition": "isRemoveShopByTestVariant",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "condition": "isClient",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v23/*: any*/),
                              (v19/*: any*/),
                              (v39/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "items",
                                "plural": true,
                                "selections": [
                                  (v41/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v34/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ShopByModule",
                            "abstractKey": null
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v23/*: any*/)
                    ],
                    "type": "LocationsModule",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "visible",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subText",
                        "storageKey": null
                      },
                      (v34/*: any*/),
                      (v42/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mobileImage",
                        "storageKey": null
                      }
                    ],
                    "type": "BottomBannerModule",
                    "abstractKey": null
                  },
                  {
                    "condition": "isClient",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v23/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "userType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "videoId",
                            "storageKey": null
                          },
                          (v42/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eyebrow",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ctaText",
                            "storageKey": null
                          },
                          (v38/*: any*/),
                          (v37/*: any*/)
                        ],
                        "type": "VideoModule",
                        "abstractKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "condition": "hasUserId",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 3
                      },
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 3
                      },
                      (v43/*: any*/)
                    ],
                    "concreteType": "PersonalizationModuleConnection",
                    "kind": "LinkedField",
                    "name": "personalization",
                    "plural": false,
                    "selections": [
                      {
                        "condition": "isNewArrivalsCarouselTabsTestVariant",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PersonalizationModuleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PersonalizationModule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Item",
                                    "kind": "LinkedField",
                                    "name": "categoryItems",
                                    "plural": true,
                                    "selections": [
                                      (v44/*: any*/),
                                      (v45/*: any*/),
                                      (v46/*: any*/),
                                      (v47/*: any*/),
                                      (v48/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v19/*: any*/),
                                      (v54/*: any*/),
                                      (v56/*: any*/),
                                      (v41/*: any*/),
                                      (v57/*: any*/),
                                      (v58/*: any*/),
                                      (v59/*: any*/),
                                      (v62/*: any*/),
                                      (v63/*: any*/),
                                      (v64/*: any*/),
                                      (v65/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v36/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "numItems",
                        "value": 10
                      },
                      {
                        "kind": "Literal",
                        "name": "pageSize",
                        "value": 3
                      },
                      (v43/*: any*/)
                    ],
                    "concreteType": "PersonalizationCollectionType",
                    "kind": "LinkedField",
                    "name": "personalizationCollections",
                    "plural": true,
                    "selections": [
                      {
                        "condition": "isNewArrivalsCarouselTabsTestVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v66/*: any*/),
                          (v36/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "categoryItems",
                            "plural": true,
                            "selections": (v67/*: any*/),
                            "storageKey": null
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              (v21/*: any*/)
            ],
            "storageKey": null
          },
          (v45/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "editorsPicks",
                "args": (v69/*: any*/),
                "concreteType": "ItemSearchItemsConnection",
                "kind": "LinkedField",
                "name": "itemSearchItems",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v70/*: any*/),
                    "storageKey": null
                  },
                  (v71/*: any*/),
                  (v72/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "editorsPicks",
                "args": (v69/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "HpSharedHeroCarousel_editorsPicks",
                "kind": "LinkedHandle",
                "name": "itemSearchItems"
              },
              (v73/*: any*/),
              (v74/*: any*/),
              {
                "condition": "isHpSaleModuleVariant",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "alias": "onSaleItems",
                    "args": (v75/*: any*/),
                    "concreteType": "ItemSearchTreandingConnection",
                    "kind": "LinkedField",
                    "name": "itemSearchTrending",
                    "plural": false,
                    "selections": (v76/*: any*/),
                    "storageKey": "itemSearchTrending(first:6,module:\"ON_SALE_MODULE\")"
                  },
                  {
                    "alias": "onSaleItems",
                    "args": (v75/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "HpSharedFeaturedModuleCarousel_onSaleItems",
                    "kind": "LinkedHandle",
                    "name": "itemSearchTrending"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OnSaleVertical",
                    "kind": "LinkedField",
                    "name": "onSaleVerticals",
                    "plural": true,
                    "selections": [
                      (v77/*: any*/),
                      (v55/*: any*/),
                      (v41/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "master"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "firstItemPhotoWebPath",
                        "storageKey": "firstItemPhotoWebPath(size:\"master\")"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "condition": "isHpSaleModuleVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OnSaleVertical",
                    "kind": "LinkedField",
                    "name": "onSaleVerticals",
                    "plural": true,
                    "selections": [
                      (v77/*: any*/),
                      (v55/*: any*/),
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "isEvergreenCollectionsTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": (v81/*: any*/)
          },
          {
            "condition": "isEvergreenCollectionsTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": (v81/*: any*/)
          },
          {
            "condition": "isNewArrivalsCarouselTabsTestVariant",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              (v17/*: any*/),
              (v73/*: any*/)
            ]
          },
          {
            "condition": "isNewArrivalsCarouselTabsTestVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              (v74/*: any*/),
              (v73/*: any*/)
            ]
          },
          {
            "condition": "hasUserId",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v43/*: any*/)
                ],
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  {
                    "alias": "hasLoggedInWithApp",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "deviceType",
                        "value": "IOS_APP"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasLoggedInWithDeviceType",
                    "storageKey": "hasLoggedInWithDeviceType(deviceType:\"IOS_APP\")"
                  },
                  (v44/*: any*/),
                  {
                    "alias": "hasMerchandizingPermission",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "BUYER_FE_MERCH_TOOL"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                  },
                  {
                    "alias": "canShowStorefrontOnlyBadge",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "name",
                        "value": "VIEW_STOREFRONT_ONLY_BADGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "hasPermission",
                    "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canShowFolder",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "testType",
                        "value": "BUYER_USER"
                      }
                    ],
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "abTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "modifiedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v20/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "audience",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ramp",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isActive",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "route",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ABTestConfigV2Variation",
                            "kind": "LinkedField",
                            "name": "variations",
                            "plural": true,
                            "selections": [
                              (v51/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "weight",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      }
                    ],
                    "storageKey": "abTestV2List(testType:\"BUYER_USER\")"
                  },
                  (v45/*: any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/558.0.0-2026-05-07T16:07:11.910Z/homepageRootQuery",
    "metadata": {},
    "name": "homepageRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7216a0e6ff2b188a49e65bd8d5a1b1c8";

export default node;
